const FreeShipping = () => {

    return  (
        <div className="search-hit__badge search-hit__badge-free-shipping">
            Versandkostenfrei (DE)
        </div>
    )
};

export default FreeShipping;
